import { createFileRoute } from '@tanstack/react-router';
import OrganizationAdmin from 'containers/OrganizationAdmin';

export const Route = createFileRoute('/_authenticated/organizationAdmin')({
  component: OrganizationAdmin,
});
